// extracted by mini-css-extract-plugin
export default {"slider":"_1Z1B7","slider-adoptables":"_1jiSL","sliderAdoptables":"_1jiSL","slider-item":"_1Y5ux","sliderItem":"_1Y5ux"};